import { FormFieldTypes } from "../../../data/formFieldType";

export const AddEditBordMember = {
  name: "AddEditBordMemberFormData",

  initialState: {
    name: "",
    email: "",
    typeofMember: "",
    // password:"",
    // confirmPassword:""   
  },


  formFields: [ 
    {
      id: "name",
      lable: "Name",
      Field_Name: "Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "name",
      fieldSetting: {
        placeholder: "Name",
        allowSpace: true,
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-6 mb-2",
      },
    },
    {
      id: "email",
      lable: "Email Address",
      Field_Name: "Email Address",
      fieldType: FormFieldTypes.INPUT,
      dataField: "email",
      fieldSetting: {
        placeholder: "Email Address",
        allowSpace: true,
      },
      validation: [{ type: "require" },{type :"email"}],
      style: {
        containerCss: "col-md-6 mb-2",
      },
    },
    {
      id: "typeofMember",
      lable: "Board Appointment",
      Field_Name: "Board Appointment",
      fieldType: FormFieldTypes.SELECT,
      dataField: "typeofMember",
      fieldSetting: {
        placeholder: "Select",
        options: [],
      },
      validation: [{ type: "require" }],
      style: {
        containerCss: "col-md-12 mb-2",
      },
    },
    //  {
    //   id: "password",
    //   lable: "Password",
    //   Field_Name: "Password",
    //   fieldType: FormFieldTypes.PASSWORD,
    //   dataField: "password",
    //   fieldSetting: {
    //     placeholder: "Password",
    //     allowSpace: false,
    //   },
    //   validation: [{ type: "require" },{type :"password"}],
    //   style: {
    //     containerCss: "col-md-6 mb-2",
    //   },
    // },
    // {
    //   id: "confirmPassword",
    //   lable: "Confirm Password",
    //   Field_Name: "Confirm Password",
    //   fieldType: FormFieldTypes.PASSWORD,
    //   dataField: "confirmPassword",
    //   fieldSetting: {
    //     placeholder: "Confirm Password",
    //     allowSpace: false,
    //   },
    //   validation: [{ type: "require" },{type :"password"}],
    //   style: {
    //     containerCss: "col-md-6 mb-2",
    //   },
    // },
    //    {
    //   id: "Password must contain at least 12 alphanumeric, 1 special character, 1 digit, 1 lower and upper case character.",
    //   lable: "Password must contain at least 12 alphanumeric, 1 special character, 1 digit, 1 lower and upper case character.",
    //   Field_Name: "Password must contain at least 12 alphanumeric, 1 special character, 1 digit, 1 lower and upper case character. ",
    //   fieldType: FormFieldTypes.MAINFORMTITLE,
    //   dataField: "Password must contain at least 12 alphanumeric, 1 special character, 1 digit, 1 lower and upper case character.",
    //   fieldSetting: {
    //     formTitle: "Password must contain at least 12 alphanumeric, 1 special character, 1 digit, 1 lower and upper case character.",
    //   },
    //   style: {
    //     containerCss: "col-lg-12 mb-2 mt-2 text-left pass-info",
    //   },
    // },
  ],

  formSetting: {
    isViewOnly: false,
  },
};
